import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { StyledFormGroup, Feedback, BOARD_OPTIONS } from './Common';
import LocationFields from './LocationFields';
import InstitutionField from './InstitutionField';

const SchoolForm = ({
    register,
    sectionErrors,
    detailsPath,
    states,
    districts,
    institutions,
    setValue,
    onInstitutionAdded,
    selectedState,
    selectedDistrict,
    level
}) => {
    return (
        <>
            <LocationFields
                register={register}
                detailsPath={detailsPath}
                sectionErrors={sectionErrors}
                states={states}
                districts={districts}
                selectedState={selectedState}
            />

            <Row>
                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Grade <span className="text-danger">*</span></Form.Label>
                    <Form.Select {...register(`${detailsPath}.grade`)} isInvalid={!!sectionErrors.grade}>
                        <option value="">Select Grade</option>
                        {[...Array(12)].map((_, i) => (
                            <option key={i + 1} value={i + 1}>Grade {i + 1}</option>
                        ))}
                    </Form.Select>
                    <Feedback error={sectionErrors.grade} />
                </StyledFormGroup>

                <InstitutionField
                    label="School Name"
                    fieldName="schoolName"
                    register={register}
                    setValue={setValue}
                    sectionErrors={sectionErrors}
                    detailsPath={detailsPath}
                    institutions={institutions}
                    onInstitutionAdded={onInstitutionAdded}
                    selectedState={selectedState}
                    selectedDistrict={selectedDistrict}
                    level={level}
                />

                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Place <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="text" placeholder="Enter Place"
                        {...register(`${detailsPath}.place`)}
                        isInvalid={!!sectionErrors.place}
                    />
                    <Feedback error={sectionErrors.place} />
                </StyledFormGroup>
            </Row>

            <Row>
                <StyledFormGroup as={Col} md="4">
                    <Form.Label>Board <span className="text-danger">*</span></Form.Label>
                    <Form.Select {...register(`${detailsPath}.board`)} isInvalid={!!sectionErrors.board}>
                        <option value="">Select Board</option>
                        {BOARD_OPTIONS.map(b => <option key={b} value={b}>{b}</option>)}
                    </Form.Select>
                    <Feedback error={sectionErrors.board} />
                </StyledFormGroup>
            </Row>
        </>
    );
};

export default SchoolForm;
